﻿"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValidatorBnBContract = exports.ValidatorBnBStat = void 0;
const ContractFacade_1 = require("./abstact/ContractFacade");
const ValidatorBnBABI_1 = require("./abi/ValidatorBnBABI");
class ValidatorBnBStat {
}
exports.ValidatorBnBStat = ValidatorBnBStat;
class ValidatorBnBContract extends ContractFacade_1.ContractFacade {
    constructor(address, web3) {
        super(address, web3, ValidatorBnBABI_1.ValidatorBnBABI.GetABI());
    }
    getStatistic() {
        return __awaiter(this, void 0, void 0, function* () {
            const value = yield this._call("statistics");
            const result = new ValidatorBnBStat();
            result.lastSwapTimestamp = value.lastSwapTimestamp;
            result.lastSwapAmountPLS = this._toEther(value.lastSwapAmountPLS);
            result.totalSwapAmountPLS = this._toEther(value.totalSwapAmountPLS);
            result.totalBurnUp = this._toEther(value.totalBurnUp);
            return result;
        });
    }
}
exports.ValidatorBnBContract = ValidatorBnBContract;
//# sourceMappingURL=ValidatorBnBContract.js.map